import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Table, Select, Image } from "antd";
import { showConfirmDlgWidget } from 'components/ConfirmDlgWidget/showConfirmDlgWidget';
import { getCurrencyInfo } from 'utils/GlobalFunctions';
const { Option } = Select;

function TableWidget(props) {
    const [isBusy, setIsBusy] = useState(false);
    const { dataList, setDataList, onDeleteAction,onDuplicateAction, onUpdateAction } = props;

    function createMarkup(html) {
        return { __html: html };
    }

    if (dataList === undefined) return <div />

    const columns = [
        {
            title: "ID",
            dataIndex: "id",
        },
        {
            title: "Name",
            dataIndex: "name",
            align: "center",
            sorter: {
                compare: (a, b) => a.name.localeCompare(b.name),
            },
        },
        {
            title: "Avatar",
            dataIndex: "thumbnail_image",
            render: (text, record) => {
                if (record.avatar_image === null) {
                    return (
                        <img className="recipe-thumbnail-img" src={'/assets/icons/ic_picture.svg'} />
                    )
                }
                else {
                    return (
                        <Image className="recipe-thumbnail-img"
                            src={record.thumbnail_image}
                        />
                        // <img className="recipe-thumbnail-img" src={record.thumbnail_image} />
                    )
                }

            },
        },
        {
            title: "Description",
            dataIndex: "description",
            align: "center",
            sorter: {
                compare: (a, b) => a.description.localeCompare(b.description),
            }
        },
        {
            title: "Month",
            dataIndex: "month_date",
            align: "center",
            sorter: {
                compare: (a, b) => a.month_date.localeCompare(b.month_date),
            },
            render: (text, record) => {
                if (record.is_year_salary === "0") {
                    return <div>{text}</div>
                }
                else {
                    return <div style={{ textDecorationLine: 'line-through', color: 'lightgrey' }}>{text}</div>
                }
            }
        },
        {
            title: "Month Salary",
            dataIndex: "month_salary",
            align: "center",
            sorter: {
                compare: (a, b) => a.month_salary - b.month_salary,
            },
            render: (text, record) => {
                if (record.is_year_salary === "0") {
                    return <div>$ {text}</div>
                }
                else {
                    return <div style={{ textDecorationLine: 'line-through', color: 'lightgrey' }}>$ {text}</div>
                }
            }
        },
        {
            title: "Year",
            dataIndex: "year_date",
            align: "center",
            sorter: {
                compare: (a, b) => a.year_date.localeCompare(b.year_date),
            },
            render: (text, record) => {
                const year = new Date(text).getFullYear(); // This will safely extract the year
                if (record.is_year_salary === "1") {
                    return <div>{year}</div>
                }
                else {
                    return <div style={{ textDecorationLine: 'line-through', color: 'lightgrey' }}>{year}</div>
                }
            }

        },
        {
            title: "Year Salary",
            dataIndex: "year_salary",
            align: "center",
            sorter: {
                compare: (a, b) => a.year_salary - b.year_salary,
            },
            render: (text, record) => {
                if (record.is_year_salary === "1") {
                    return <div>$ {text}</div>
                }
                else {
                    return <div style={{ textDecorationLine: 'line-through', color: 'lightgrey' }}>$ {text}</div>
                }
            }
        },
        {
            title: "Method",
            align: "center",
            dataIndex: "is_year_salary",
            sorter: {
                compare: (a, b) => a.is_year_salary - b.is_year_salary,
            },
            render: (text, record) => {
                if (record.is_year_salary === "1") {
                    return <span className="year-method">&nbsp;&nbsp;Year&nbsp;&nbsp;</span>
                }
                else {
                    return <span className="month-method">Month</span>
                }
            }
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            render: (text, record) => {
                return (
                    <div size="middle" direction={"vertical"}>
                        <a className="edit-btn"
                            onClick={() => {
                                onUpdateAction(record)
                            }}
                        >
                            Edit
                        </a>
                        <a style={{ color: "var(--orangeColor)", marginLeft: 20 }} className="del-btn" onClick={async () => {
                            onDuplicateAction(record)
                        }}>
                            Duplicate
                        </a>
                        <a style={{ color: "var(--redColor)", marginLeft: 20 }} className="del-btn" onClick={async () => {
                            var res = await showConfirmDlgWidget({ title: "Delete Confirmation", content: "Are you sure to delete this item?" });
                            if (res == false) return;
                            onDeleteAction(record)
                        }}>
                            Delete
                        </a>
                    </div>
                );
            },
        },
    ];
    const dataSource = dataList.map((info) => {
        return { ...info, key: info.id };
    });

    return (
        <div className="list-table">
            <Table
                pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40', '50'] }}
                columns={columns}
                dataSource={dataSource}
            />
        </div>
    )
}

export default withRouter(TableWidget)
